import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator reads the tile's proportions and which way it faces. */
export const AlurePatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="alure"
    width={{ value: "7.5", min: 3, max: 30, labelKey: "TILE_WIDTH" }}
    height={{ value: "20", min: 5, max: 60, labelKey: "TILE_HEIGHT" }}
  />
);
